module.exports = __webpack_public_path__ + "static/bronze_sable-2050aa91467e69b78fb64f863a307aae.jpeg";